// Libraries
import React from 'react';

// Supermove
import {CommunicationKindModel} from '@supermove/models';

// App
import Tabs from '@shared/design/components/Tabs';
import {CommunicationCounts} from '@shared/modules/Communication/types/CommunicationCounts';

type CommunicationKindModelWithAll = CommunicationKindModel | 'ALL';

const tabs: Record<
  CommunicationKindModelWithAll,
  {key: CommunicationKindModelWithAll; label: string; count: number; index: number}
> = {
  ALL: {
    key: 'ALL',
    label: 'All',
    count: 0,
    index: 0,
  },
  EMAIL: {
    key: 'EMAIL',
    label: 'Email',
    count: 0,
    index: 1,
  },
  SMS: {
    key: 'SMS',
    label: 'SMS',
    count: 0,
    index: 2,
  },
  CALL: {
    key: 'CALL',
    label: 'Call',
    count: 0,
    index: 3,
  },
};

const CommunicationsWidgetTabs = ({
  activeTab,
  handleChangeTab,
  communicationCounts,
}: {
  activeTab?: CommunicationKindModel;
  handleChangeTab: (newActiveTag?: CommunicationKindModel) => void;
  communicationCounts: CommunicationCounts;
}) => {
  return (
    <Tabs
      tabs={[
        {
          ...tabs.ALL,
          count:
            communicationCounts.emailCount +
            communicationCounts.textMessageCount +
            communicationCounts.callCount,
        },
        {...tabs.EMAIL, count: communicationCounts.emailCount},
        {...tabs.SMS, count: communicationCounts.textMessageCount},
        {...tabs.CALL, count: communicationCounts.callCount},
      ]}
      handlePressTab={({key}) => {
        if (key === 'ALL') {
          // All is the default, so we don't need to set it
          handleChangeTab();
        } else {
          handleChangeTab(key);
        }
      }}
      activeTabIndex={activeTab ? tabs[activeTab].index : 0}
      TabComponent={Tabs.SecondaryTab}
      tabStyle={{paddingLeft: 22, paddingRight: 22}}
      isSpacedTabs={false}
    />
  );
};

export default CommunicationsWidgetTabs;
